import { createContext, use } from "react";

export interface ChromeOrg {
  readonly id: string;
  readonly name: string;
}

/** Shared by the title bar, the worker popover and the toasts. Null outside the desktop app. */
export interface DesktopChromeState {
  /** Set from inside the signed-in frame, so the title bar can name the org and query its runs. */
  readonly org: ChromeOrg | null;
  readonly setOrg: (org: ChromeOrg | null) => void;
  /** The worker popover, opened from the title bar or the crash toast's Details. */
  readonly workerOpen: boolean;
  readonly setWorkerOpen: (open: boolean) => void;
}

export const DesktopChromeContext = createContext<DesktopChromeState | null>(null);

export const useDesktopChrome = () => use(DesktopChromeContext);
